import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Markdown from "markdown-to-jsx";
const BlockWrapper = styled(Box)({
  maxWidth: "800px",
  "& pre": {
    flex: "1 0 0",
    width: "inherit",
    height: "100%",
    overflow: "auto",
    "& code": {
      fontFamily: "inherit",
      fontSize: "inherit",
      color: "inherit"
    }
  }
});
const TextBlock = t0 => {
  const $ = c(26);
  const {
    text,
    isLoading: t1
  } = t0;
  const isLoading = t1 === void 0 ? false : t1;
  const theme = useTheme();
  if (isLoading) {
    let t22;
    if ($[0] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
      t22 = /* @__PURE__ */jsx(Skeleton, {
        variant: "text",
        width: 350,
        height: 80
      });
      $[0] = t22;
    } else {
      t22 = $[0];
    }
    return t22;
  }
  let t2;
  if ($[1] !== theme.markdownReplacements.p) {
    t2 = {
      component: Typography,
      props: {
        ...theme.markdownReplacements.p
      }
    };
    $[1] = theme.markdownReplacements.p;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== theme.markdownReplacements.h1) {
    t3 = {
      component: Typography,
      props: {
        ...theme.markdownReplacements.h1
      }
    };
    $[3] = theme.markdownReplacements.h1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== theme.markdownReplacements.h2) {
    t4 = {
      component: Typography,
      props: {
        ...theme.markdownReplacements.h2
      }
    };
    $[5] = theme.markdownReplacements.h2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== theme.markdownReplacements.h3) {
    t5 = {
      component: Typography,
      props: {
        ...theme.markdownReplacements.h3
      }
    };
    $[7] = theme.markdownReplacements.h3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== theme.markdownReplacements.h4) {
    t6 = {
      component: Typography,
      props: {
        ...theme.markdownReplacements.h4
      }
    };
    $[9] = theme.markdownReplacements.h4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== theme.markdownReplacements.h5) {
    t7 = {
      component: Typography,
      props: {
        ...theme.markdownReplacements.h5
      }
    };
    $[11] = theme.markdownReplacements.h5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== theme.markdownReplacements.h6) {
    t8 = {
      component: Typography,
      props: {
        ...theme.markdownReplacements.h6
      }
    };
    $[13] = theme.markdownReplacements.h6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = {
      forceBlock: true,
      wrapper: "div",
      overrides: {
        p: t2,
        h1: t3,
        h2: t4,
        h3: t5,
        h4: t6,
        h5: t7,
        h6: t8
      }
    };
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9 || $[24] !== text) {
    t10 = /* @__PURE__ */jsx(BlockWrapper, {
      children: /* @__PURE__ */jsx(Markdown, {
        options: t9,
        children: text
      })
    });
    $[23] = t9;
    $[24] = text;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export { TextBlock as default };